// @flow
import { createContext } from 'react';
import type { Context } from 'react';

type AlertContextType = {
  setAlert: Function,
  alert: Object,
};

export const AlertContext: Context<AlertContextType> = createContext({
  setAlert: () => null,
  alert: {},
});
